import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import { supabase } from '../../lib/supabase'
import './Dashboard.css'

export default function Dashboard() {
  const { user, profile } = useApp()
  const navigate = useNavigate()
  const [stats, setStats] = useState(null)
  const [astazi, setAstazi] = useState(null)
  const [loading, setLoading] = useState(true)

  const today = new Date().toISOString().split('T')[0]

  useEffect(() => {
    loadStats()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function loadStats() {
    const { data: zile } = await supabase
      .from('progres_zilnic')
      .select('*')
      .eq('user_id', user.id)
      .order('data', { ascending: false })

    if (zile) {
      const zileFaraJoc = zile.filter(z => z.zile_fara_joc).length
      const streak = calcStreak(zile)
      const ziuaDeAzi = zile.find(z => z.data === today)

      // Aggregate slot stats across all days
      let pierduteTotal = 0
      let datoriiTotal = 0
      let baniAcasaTotal = 0
      let allDatorii = []
      zile.forEach(z => {
        const s = z.slot_sesiune
        if (s) {
          pierduteTotal += s.pierderi_totale || 0
          datoriiTotal += s.datorie_curenta || 0
          baniAcasaTotal += s.bani_de_acasa || 0
          if (s.datorii?.length) allDatorii = allDatorii.concat(s.datorii)
        }
      })

      setStats({
        zileFaraJoc, streak, total: zile.length,
        pierduteTotal, datoriiTotal, baniAcasaTotal, allDatorii,
      })
      setAstazi(ziuaDeAzi)
    }
    setLoading(false)
  }

  function calcStreak(zile) {
    let streak = 0
    const sorted = [...zile].sort((a, b) => b.data.localeCompare(a.data))
    for (const z of sorted) {
      if (z.zile_fara_joc) streak++
      else break
    }
    return streak
  }

  async function bifaZiuaDeAzi() {
    const { error } = await supabase.from('progres_zilnic').upsert({
      user_id: user.id,
      data: today,
      zile_fara_joc: true,
    })
    if (!error) loadStats()
  }

  const financiar = profile?.profil_financiar
  const baniEconomisiti = stats ? Math.round((stats.zileFaraJoc || 0) * (financiar?.buget_zilnic_joc || 20)) : 0

  if (loading) return <div className="loading-screen">Se incarca...</div>

  return (
    <div className="dashboard">
      <div className="dash-header">
        <div>
          <h1>Buna ziua 👋</h1>
          <p className="dash-date">{new Date().toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' })}</p>
        </div>
        {profile?.gravitate && (
          <span className={`badge badge-level badge-${profile.gravitate.nivel}`}>
            Nivel: {profile.gravitate.nivel}
          </span>
        )}
      </div>

      {/* STATS PRINCIPALE */}
      <div className="dash-stats">
        <div className="dash-stat-main">
          <div className="stat-big-num">{stats?.streak || 0}</div>
          <div className="stat-big-lbl">zile consecutive fara joc</div>
          <div className="stat-big-sub">Record personal: {stats?.zileFaraJoc || 0} zile</div>
        </div>
        <div className="dash-stat-money">
          <div className="stat-money-num">{baniEconomisiti} lei</div>
          <div className="stat-money-lbl">economisiti total</div>
          <div className="stat-money-sub">vs ce ai fi pierdut</div>
        </div>
      </div>

      {/* BIFA ZIUA DE AZI */}
      <div className="dash-today">
        {astazi?.zile_fara_joc ? (
          <div className="today-done">
            <span className="today-check">✓</span>
            <div>
              <div className="today-done-title">Ziua de azi bifata!</div>
              <div className="today-done-sub">Continua asa. Esti pe drumul cel bun.</div>
            </div>
          </div>
        ) : (
          <div className="today-pending">
            <div className="today-pending-text">
              <h3>Bifezi ziua de azi?</h3>
              <p>Confirma ca nu ai jucat la pacănele astazi.</p>
            </div>
            <button className="btn-primary" onClick={bifaZiuaDeAzi}>
              Da, confirm ✓
            </button>
          </div>
        )}
      </div>

      {/* ACTIUNI RAPIDE */}
      <div className="dash-actions">
        <h2>Activitatile tale</h2>
        <div className="dash-actions-grid">
          <div className="action-card" onClick={() => navigate('/slot')}>
            <div className="action-icon">🎰</div>
            <div className="action-title">Simulator slot</div>
            <div className="action-desc">Sesiunea de terapie de azi</div>
            <div className="action-arrow">→</div>
          </div>
          <div className="action-card" onClick={() => navigate('/calendar')}>
            <div className="action-icon">📅</div>
            <div className="action-title">Calendar</div>
            <div className="action-desc">Progresul tau vizual</div>
            <div className="action-arrow">→</div>
          </div>
          <div className="action-card" onClick={() => navigate('/jurnal')}>
            <div className="action-icon">📓</div>
            <div className="action-title">Jurnal</div>
            <div className="action-desc">Cum te simti azi?</div>
            <div className="action-arrow">→</div>
          </div>
          <div className="action-card" onClick={() => navigate('/educatie')}>
            <div className="action-icon">💡</div>
            <div className="action-title">Educatie</div>
            <div className="action-desc">Cum functioneaza aparatele</div>
            <div className="action-arrow">→</div>
          </div>
        </div>
      </div>

      {/* SITUATIA TA - datorii, bani de acasa, pierderi */}
      {stats && (stats.pierduteTotal > 0 || stats.datoriiTotal > 0 || stats.baniAcasaTotal > 0) && (
        <div className="dash-situatia">
          <h2>Situatia ta</h2>
          <div className="situatia-grid">
            {stats.pierduteTotal > 0 && (
              <div className="situatia-card situatia-pierderi">
                <div className="situatia-icon">📉</div>
                <div className="situatia-num">{stats.pierduteTotal} lei</div>
                <div className="situatia-lbl">pierderi totale</div>
              </div>
            )}
            {stats.datoriiTotal > 0 && (
              <div className="situatia-card situatia-datorii">
                <div className="situatia-icon">🤝</div>
                <div className="situatia-num">{stats.datoriiTotal} lei</div>
                <div className="situatia-lbl">datorii la prieteni</div>
              </div>
            )}
            {stats.baniAcasaTotal > 0 && (
              <div className="situatia-card situatia-acasa">
                <div className="situatia-icon">💸</div>
                <div className="situatia-num">{stats.baniAcasaTotal} lei</div>
                <div className="situatia-lbl">bani bagati de acasa</div>
              </div>
            )}
          </div>
          {stats.allDatorii.length > 0 && (
            <div className="datorii-detail">
              <h3>Datorii detaliate</h3>
              <ul className="datorii-lista-dash">
                {stats.allDatorii.map((d, i) => (
                  <li key={i}><span>{d.nume}</span><span className="red">{d.suma} lei</span></li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* BUGET ZILNIC */}
      {financiar && (
        <div className="dash-budget">
          <h2>Bugetul tau zilnic</h2>
          <div className="budget-grid">
            {Object.entries(financiar.cheltuieli)
              .filter(([, val]) => val > 0)
              .map(([key, val]) => (
                <div key={key} className="budget-item">
                  <div className="budget-item-label">{labelCheltuiala(key)}</div>
                  <div className="budget-item-value">{val} lei/zi</div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  )
}

function labelCheltuiala(key) {
  const map = { mancare_zilnic: 'Mancare', utilitati_zilnic: 'Utilitati', rata_zilnic: 'Rata/Chirie', copii_zilnic: 'Copii', transport_zilnic: 'Transport', alte_zilnic: 'Altele' }
  return map[key] || key
}
